// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { LocationDescriptorObject } from 'history';

import Button, { ButtonProps } from '@shared/components/Button';
import history from '@shared/utils/history';

type Classes = Pick<ButtonProps, 'classes'>;

export interface BackButtonProps extends Omit<ButtonProps, 'classes'>, Classes {
  className?: string;
  link?: string;
  location?: LocationDescriptorObject;
  text?: React.ReactNode;
  children?: React.ReactNode;
}

const BackButton: React.FC<BackButtonProps> = (props: BackButtonProps) => {
  const { text = 'Back', children, location, link, onClick } = props;
  const classes = withStyles.getClasses(props);
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);

      return;
    }

    if (link) {
      history.push(link);

      return;
    }

    if (location) {
      history.push(location);

      return;
    }

    history.goBack();
  };
  const { root: rootClass, iconWrapper: iconWrapperClass, ...otherClasses } = classes;

  return (
    <Button
      size="small"
      variant="outlined"
      color="primary"
      onClick={handleClick}
      classes={{
        root: rootClass,
        ...otherClasses
      }}
    >
      <span className={iconWrapperClass}>
        {/* <LeftArrowIcon /> */}
        <ChevronLeftIcon />
      </span>
      {children || text}
    </Button>
  );
};

// Replace by default parameters when deconstructing.
// BackButton.defaultProps = {
//   text: 'Back',
// };

const BackButtonStyled = withStyles(
  BackButton, 
  (theme, props) => ({
    "root": {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(0, 3, 0, 1),
      background: 'white',
      color: theme.palette.colors.primaryAccent,
    },
    "iconWrapper": {
      display: 'flex',
      marginRight: theme.spacing(),
    }
  })
);

export default BackButtonStyled;